<h1 mat-dialog-title class="textoCenter">Identificamos que o componente <b>CriptoCNS</b> não está instalado em sua máquina!</h1>
<div mat-dialog-content class="textoCenter">
  <p><b>Favor efetuar o download e a sua instalação!</b></p>
  <p>Informações adicionais podem ser verificadas no Manual Operacional CNS ICP V2, disponível no site <a href="http://www.caixa.gov.br" target="_blank"> www.caixa.gov.br</a>, opção Downloads, Tópico: FGTS - Manuais e Cartilhas Operacionais. </p>
</div>
<div mat-dialog-actions class="botoes">
  <button mat-raised-button  class="md-icon-button btnOK" (click)="onYesClick()" cdkFocusInitial>
    <img alt='' class="img-fluid" src="assets/icons/save_alt_white.png"  width="24px"/> Download
  </button>
</div>